// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"362":"a3f51a8c","630":"2ea36eca","799":"f288dd2b"}[chunkId] + ".chunk.css";
};